<template>
  <div id="app">
    <banner-view></banner-view>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import BannerView from "./base/Banner";
  import FooterView from "./base/Footer";
  export default {
    name: "App",
    components: {
      BannerView,
      FooterView
    }
  };
</script>



// WEBPACK FOOTER //
// src/App.vue